import React,{useEffect, useState, useRef, useMemo} from 'react';
import './warning.css';

function Warning({goNext, language, setLang }) {
  const [white, setWhite] = useState(0);
  const [clicked, setClicked] = useState(true);
  const noMinors = useRef(null);
  const disclaimer = useRef(null);
  const languageSelect = useRef(null);
  const txtRef = useRef(null);
  let num = useRef(0);

  let text = {
    en:{
      chooseLang:"Choose language:",
      tapTo:"Tap to continue",
      pg:"18+",
      noMinors:"No minors allowed",
      titleDisc:"Disclaimer",
      disclaimer1:"All characters appearing in this work are fictitious and are 18 years old or above. Any resemblance to real persons, living or dead, is purely coincidental.",
      disclaimer2:"The game does not claim the depth of presented knowledge and is mainly designed for entertainment, please take what is happening with some irony.",
      disclaimer3:"Sex educator SHOULD NOT participate in the sex process and can only help with theory and mental or emotional aspects of sex-related problems (if certified as a therapist).",
    },
    ru:{
      chooseLang:"Выберите язык:",
      tapTo:"Нажмите, чтобы продолжить",
      pg:"18+",
      noMinors:"Контент только для взрослых",
      titleDisc:"Дисклеймер",
      disclaimer1:"Все персонажи данного произведения являются вымышленными и достигли 18-летнего возраста. Любое сходство с реальными лицами, живыми или умершими, является совпадением.",
      disclaimer2:"Эта игра не претендует на глубину представленных знаний и предназначена в первую очередь для развлечения, прошу относиться к происходящему в ней с долей иронии.",
      disclaimer3:"Сексолог НЕ ДОЛЖЕН принимать участие в половом акте и может помогать только в вопросах теории, а также в решении психологических или эмоциональных аспектов проблем, связанных с сексом (если является дипломированным психологом).",
    }
  }

  useEffect(() => {
    if(language == "en"){
      document.getElementById("option-one").defaultChecked = "true";
    }else if(language == "ru"){
      document.getElementById("option-two").defaultChecked = "true";
    }
  },[]);

function langSelect(e){
  setLang(e.currentTarget.value);
}
  async function go(){

    await goo();
       function goo(){
            return new Promise( async (resolve, reject) => {
              setClicked(false);
              if(num.current == 0){
                languageSelect.current.style.zIndex = "1";
                txtRef.current.style.zIndex = "1";
                await changeWhite();
                languageSelect.current.style.display = "none";
                noMinors.current.style.display = "block";
                await changeWhite(true);
                setClicked(true);
                num.current++;
                resolve();
              }else if(num.current == 1){
                await changeWhite();
                noMinors.current.style.display = "none";
                disclaimer.current.style.display = "block";
                await changeWhite(true);
                setClicked(true);
                num.current++;
                resolve();
              }else if(num.current > 1){
                await changeWhite();
                goNext();
                resolve();
              }
              });
            }
  }



  function changeWhite(toLow){
    return new Promise((resolve, reject) => {
    if(toLow){
      var op=1;
      change(toLow);
    }else{
      var op=0;
      change();
    }
    function change(toLow){
    if(toLow){
      if(op>0){
        op-=0.03;
      setWhite(op);
      setTimeout(ChangetoLow, 10);
    }else{
      resolve();
      return;
    }
  }else{
    if(op<1){
      op+=0.03;
    setWhite(op);
    setTimeout(change, 10);
  }else{
    resolve();
    return;
  }
  }

  function ChangetoLow(){
     change(true);
  }
  }
  });
  }

return(
<div className='blcwrap'>
<div className='clickWrap' onClick={clicked? go : undefined} id='wrap' style={{opacity:white}}></div>
<div className='txt1' ref={txtRef} style={{zIndex:"20"}}>
<div style={{display:"block", zIndex:"20"}} className="languageSelect" ref={languageSelect}>
<h1 style={{fontSize:"30px"}} onClick={clicked? go : undefined}>{text[language]["chooseLang"]}</h1>
<form>
 <div className="radio-group">
<input type="radio" id="option-one" name="selector" value="en" onClick={langSelect} /><label htmlFor="option-one">English</label>
<input type="radio" id="option-two" name="selector" value="ru" onClick={langSelect} /><label htmlFor="option-two">Русский</label>
  </div>
   </form>
<br/>
<h2 onClick={clicked? go : undefined}>{text[language]["tapTo"]}</h2>
</div>
<div style={{display:"none"}} ref={noMinors}>
<h1 style={{fontSize:"30px", color:"#ea4f2e"}}>{text[language]["pg"]}</h1>
<h1 style={{fontSize:"25px", color:"#ea4f2e"}}>{text[language]["noMinors"]}</h1>
<h2 style={{marginTop:"1vh"}}>{text[language]["disclaimer1"]}</h2>
<br/>
<h2>{text[language]["tapTo"]}</h2>
</div>
<div style={{display:"none"}} ref={disclaimer}>
<h1 style={{fontSize:"30px", color:"#ea4f2e"}}>{text[language]["titleDisc"]}</h1>
<h2 style={{marginTop:"2vh"}}>{text[language]["disclaimer2"]}</h2>
<h2 style={{marginTop:"3vh", fontSize:"18px", color:"#ea4f2e"}}>{text[language]["disclaimer3"]}</h2>
<br/>
<h2>{text[language]["tapTo"]}</h2>
</div>
</div>
</div>
);

}

export default Warning;
